import { render, staticRenderFns } from "./PolitiqueDeConfidentialite.vue?vue&type=template&id=6abe95fc&scoped=true"
import script from "./PolitiqueDeConfidentialite.vue?vue&type=script&lang=js"
export * from "./PolitiqueDeConfidentialite.vue?vue&type=script&lang=js"
import style0 from "./PolitiqueDeConfidentialite.vue?vue&type=style&index=0&id=6abe95fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe95fc",
  null
  
)

export default component.exports